(() => {
  'use strict';

  window.FramewerkSearchConfig = Object.freeze({
    version: '2.0.0',
    storageKey: 'framewerk-search-recent-v2',
    validationStorageKey: 'framewerk-search-valid-presets-v2',
    cacheTtl: 5 * 60 * 1000,
    validationTtl: 6 * 60 * 60 * 1000,
    requestTimeout: 8000,
    maxRecent: 6,
    maxPredictiveResults: 12,
    maxMergedProducts: 18,
    maxExpansionQueries: 4,
    modelCodes: Object.freeze([
      'VB','VC','VH','VK','VL','VN','VP','VQ',
      'VR','VS','VT','VX','VY','VZ','VE','VF'
    ])
  });
})();
